<template>
  <div>
    <!--Topbar Start Here-->
    <header class="topbar clearfix">
      <!--Top Search Bar Start Here-->
      <div class="top-search-bar">
        <div class="search-input-addon">
          <span class="addon-icon pointer" @click="startSearchKeyWord()"><i class="zmdi zmdi-search"></i></span>
          <input type="text" v-model="keyword" class="form-control top-search-input" placeholder="搜尋關鍵字" @keyup.enter="searchKeyWord()" @focus="showResult=true">
          <img v-if="loading==true" class="top-search-loading-image" src="../../assets/img/cat/cat-loading.gif">
        </div>
      </div>
      <div class="top-search-result" v-if="showResult==true && searchResult!= ''" v-click-outside="hide">
        <ul class="nav nav-tabs nav-center" role="tablist">
          <li role="presentation" class="active">
            <a href="#all" aria-controls="deals_result" role="tab" data-toggle="tab">
            All ({{totalSearchResult}})
          </a>
          </li>
          <li role="presentation" v-if="searchResult['Deals'].length!=0">
            <a href="#deals_result" aria-controls="deals_result" role="tab" data-toggle="tab">
            <i class="fas fa-dollar-sign"></i> ({{searchResult["Deals"].length}})
          </a>
          </li>
          <li role="presentation" v-if="searchResult['Contacts'].length!=0">
            <a href="#contacts_result" aria-controls="contacts_result" role="tab" data-toggle="tab">
            <i class="fa fa-user"></i> ({{searchResult["Contacts"].length}})
          </a>
          </li>
          <li role="presentation" v-if="searchResult['Organizations'].length!=0">
            <a href="#organizations_result" aria-controls="organizations_result" role="tab" data-toggle="tab">
            <i class="fa fa-building"></i> ({{searchResult["Organizations"].length}})
          </a>
          </li>
          <li role="presentation" v-if="searchResult['Quotations'].length!=0">
            <a href="#quotations_result" aria-controls="quotations_result" role="tab" data-toggle="tab">
            <i class="fa fa-file"></i> ({{searchResult["Quotations"].length}})
          </a>
          </li>
          <li role="presentation" v-if="searchResult['Attachments'].length!=0">
            <a href="#attachments_result" aria-controls="attachments_result" role="tab" data-toggle="tab">
            <i class="fa fa-paperclip"></i> ({{searchResult["Attachments"].length}})
          </a>
          </li>
        </ul>
        <div class="tab-content search-panel">
          <div role="tabpanel" class="tab-pane active" id="all">
            <div class="single-result deal-result pointer" v-for="deal in searchResult['Deals']">
              <div @click="ShowDeal(deal.deal_token)">
                <div class="result-icon">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{deal.title}}</div>
                  <small class="result-subtitle">{{deal.contact.name}} , $ {{deal.value.toLocaleString()}}</small>
                </div>
                <div class="result-status">
                  <span class="label label-success" v-if="deal.status=='won'">完成</span>
                  <span v-if="deal.status=='open'">進行中</span>
                  <span class="label label-danger" v-if="deal.status=='lost'">失去</span>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-for="contact in searchResult['Contacts']">
              <div @click="ShowContact(contact.contact_token)">
                <div class="result-icon">
                  <img src="../../assets/img/no-avatar.jpg" class="img-thumbnail img-circle" style="border:none">
            		</div>
                <div class="result-content">
                  <div class="result-title">{{contact.name}}</div>
                  <small class="result-subtitle">{{contact.email || '無email'}} , {{contact.phone || '無手機'}},{{contact.organization.name}}</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-for="organization in searchResult['Organizations']">
              <div @click="ShowOrganization(organization.organization_token)">
                <div class="result-icon">
                  <i class="fa fa-building"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{organization.name}}</div>
                  <small class="result-subtitle" v-if="organization.address">{{organization.address}}</small>
                  <small class="result-subtitle" v-else>無地址</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-for="quotation in searchResult['Quotations']">
              <div @click="ShowQuotation(quotation.quotation_token)">
                <div class="result-icon">
                  <i class="fa fa-file"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">報價單：{{quotation.title}}</div>
                  <small class="result-subtitle">{{quotation.deal.title}} , 總金額: ${{(quotation.total_price||0).toLocaleString()}}</small>
                </div>
                <div class="result-status">
                  <span class="label label-success">won</span>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-for="activity in searchResult['Attachments']">
              <div @click="DownLoadFile(activity.attachment_url)">
                <div class="result-icon">
                  <i class="fa fa-paperclip"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{activity.title}}</div>
                  <small class="result-subtitle">專案:{{activity.deal.title}}</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="totalSearchResult == 0">
              <div style="padding:15px;">無任何搜尋結果</div>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="deals_result">
            <div class="single-result deal-result pointer" v-for="deal in searchResult['Deals']">
              <div @click="ShowDeal(deal.deal_token)">
                <div class="result-icon">
                  <i class="fas fa-dollar-sign"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{deal.title}}</div>
                  <small class="result-subtitle">{{deal.contact.name}} , $ {{deal.value.toLocaleString()}}</small>
                </div>
                <div class="result-status">
                  <span class="label label-success" v-if="deal.status=='won'">完成</span>
                  <span v-if="deal.status=='open'">進行中</span>
                  <span class="label label-danger" v-if="deal.status=='lost'">失去</span>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="searchResult['Deals'].length == 0">
              <div style="padding:15px;">無相關交易</div>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="contacts_result">
            <div class="single-result deal-result pointer" v-for="contact in searchResult['Contacts']">
              <div @click="ShowContact(contact.contact_token)">
                <div class="result-icon">
                  <img src="../../assets/img/no-avatar.jpg" class="img-thumbnail img-circle" style="border:none">
            		</div>
                <div class="result-content">
                  <div class="result-title">{{contact.name}}</div>
                  <small class="result-subtitle">{{contact.email || '無email'}} , {{contact.phone || '無手機'}},{{contact.organization.name}}</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="searchResult['Contacts'].length == 0">
              <div style="padding:15px;">無相關聯絡人</div>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="organizations_result">
            <div class="single-result deal-result pointer" v-for="organization in searchResult['Organizations']">
              <div @click="ShowOrganization(organization.organization_token)">
                <div class="result-icon">
                  <i class="fa fa-building"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{organization.name}}</div>
                  <small class="result-subtitle" v-if="organization.address">{{organization.address}}</small>
                  <small class="result-subtitle" v-else>無地址</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="searchResult['Organizations'].length == 0">
              <div style="padding:15px;">無相關組織</div>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="quotations_result">
            <div class="single-result deal-result pointer" v-for="quotation in searchResult['Quotations']">
              <div @click="ShowQuotation(quotation.quotation_token)">
                <div class="result-icon">
                  <i class="fa fa-file"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">報價單：{{quotation.title}}</div>
                  <small class="result-subtitle">{{quotation.deal.title}} , 總金額: ${{(quotation.total_price||0).toLocaleString()}}</small>
                </div>
                <div class="result-status">
                  <span class="label label-success">won</span>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="searchResult['Quotations'].length == 0">
              <div style="padding:15px;">無相關報價單</div>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="attachments_result">
            <div class="single-result deal-result pointer" v-for="activity in searchResult['Attachments']">
              <div @click="DownLoadFile(activity.attachment_url)">
                <div class="result-icon">
                  <i class="fa fa-paperclip"></i>
                </div>
                <div class="result-content">
                  <div class="result-title">{{activity.title}}</div>
                  <small class="result-subtitle">專案:{{activity.deal.title}}</small>
                </div>
              </div>
            </div>
            <div class="single-result deal-result pointer" v-if="searchResult['Attachments'].length == 0">
              <div style="padding:15px;">無相關檔案</div>
            </div>
          </div>
        </div>
      </div>
      <!--Top Search Bar End Here-->
      <!--Topbar Left Branding With Logo Start-->
      <div class="topbar-left pull-left">
        <div class="clearfix">
          <ul class="left-branding pull-left clickablemenu ttmenu dark-style menu-color-gradient">
            <li><span class="left-toggle-switch" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);" @click="toggle"><i class="zmdi zmdi-menu"></i></span></li>
            <li>
              <div class="logo">
                <a @click="GoDashbaord" class="pointer">
            <img style="margin-top:7px" src="../../assets/img/logo-white.png" alt="logo" height="46">
          </a>
              </div>
            </li>
          </ul>
          <!--Mobile Search and Rightbar Toggle-->
          <ul class="branding-right pull-right">
            <li><a href="#" class="btn-mobile-search btn-top-search" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"><i class="zmdi zmdi-search"></i></a></li>
            <li><a href="#" class="btn-mobile-bar" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"><i class="zmdi zmdi-menu"></i></a></li>
          </ul>
        </div>
      </div>
      <!--Topbar Left Branding With Logo End-->
      <!--Topbar Right Start-->
      <div class="topbar-right pull-right">
        <div class="clearfix">
          <!--Mobile View Leftbar Toggle-->
          <ul class="left-bar-switch pull-left">
            <li><span class="left-toggle-switch" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"><i class="zmdi zmdi-menu"></i></span></li>
          </ul>
          <ul class="pull-right top-right-icons">
            <li class="dropdown notifications-dropdown mr-3">
              <!-- <a href="#" class="btn-notification dropdown-toggle notification_drop_down" data-toggle="dropdown"><span class="noty-bubble">10</span><i class="far fa-bell"></i></a> -->
              <div class="dropdown-menu notifications-tabs">
                <div>
                  <div class="notification-wrap">
                    <h4>你有 10 個通知</h4>
                    <ul>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_purple"><i class="fa fa-bullhorn"></i></span><span class="notification-message">Pellentesque semper posuere. <span class="notification-time clearfix">3 Min Ago</span></span></a>
                      </li>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_orange"><i class="fa fa-life-ring"></i></span><span class="notification-message">Nulla commodo sem at purus. <span class="notification-time clearfix">1 Hours Ago</span></span></a>
                      </li>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_red"><i class="fa fa-star-o"></i></span><span class="notification-message">Fusce condimentum turpis. <span class="notification-time clearfix">3 Hours Ago</span></span></a>
                      </li>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_light_blue"><i class="fa fa-trophy"></i></span><span class="notification-message">Pellentesque habitant morbi. <span class="notification-time clearfix">Yesterday</span></span></a>
                      </li>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_cyan"><i class="fa fa-bolt"></i></span><span class="notification-message">Fusce bibendum lacus mauris.<span class="notification-time clearfix">1 Month Ago</span></span></a>
                      </li>
                      <li><a href="#" class="clearfix"><span class="ni w_bg_yellow"><i class="fa fa-bookmark-o"></i></span><span class="notification-message">Donec id mi placerat, scelerisque.<span class="notification-time clearfix">3 Months Ago</span></span></a>
                      </li>
                    </ul>
                    <a class="btn btn-link btn-block btn-view-all clearfix" href="#"><span>View All</span></a>
                  </div>
                </div>
              </div>
            </li>
						<!--             <li><a href="#" class="right-toggle-switch"><i class="zmdi zmdi-format-align-left"></i><span class="more-noty"></span></a></li> -->
            <li class="dropdown more-dropdown topbar-logged-user">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            		<img class="pointer" v-if="!user.profile_pic"  src="../../assets/img/logo1.png" alt="admin">
          			<img class="pointer" v-else :src="user.profile_pic" alt="admin">
            	</a>
              <div class="dropdown-menu more-apps">
                <div class="user-profile-container">
                  <div class="user-profile clearfix pointer" @click="GoUserProfile">
                    <div class="admin-user-thumb">
                      <img class="pointer" v-if="!user.profile_pic"  src="../../assets/img/logo1.png" alt="admin">
          						<img class="pointer" v-else :src="user.profile_pic" alt="admin">
                    </div>
                    <div class="admin-user-info">
                      <ul>
                        <li><a>{{user.name}}</a></li>
                        <li><a>{{user.email}}</a></li>
                      </ul>
                    </div>
                  </div>
                  <!-- <div class="admin-bar">
                    <ul>
                      <li>
                      	<a href="#" data-toggle="tooltip" data-placement="right" title="Logout"><i class="zmdi zmdi-power"></i></a>
                      </li>
                      <li>
                      	<a href="#" data-toggle="tooltip" data-placement="right" title="My Account"><i class="zmdi zmdi-account"></i></a>
                      </li>
                      <li>
                      	<a href="#" data-toggle="tooltip" data-placement="right" title="Lock"><i class="zmdi zmdi-key"></i></a>
                      </li>
                      <li>
                      	<a href="#" data-toggle="tooltip" data-placement="left" title="Settings"><i class="zmdi zmdi-settings"></i></a>
                      </li>
                    </ul>
                  </div> -->
                </div>
                <ul class="more-apps">
                  <li @click="GoUserProfile()"><a href="#"><i class="far fa-user-circle"></i> 個人資料</a></li>
                  <li v-if="user.permission == 'admin'" @click="goBills()"><a href="#"><i class="fa fa-file-invoice-dollar"></i> 帳單一覽</a></li>
                  <li v-if="user.permission == 'admin'" @click="goCreditCard()"><a href="#"><i class="far fa-credit-card"></i> 方案與付款方式</a></li>
                  <li @click="logout()"><a href="#"><i class="zmdi zmdi-power"></i> 登出</a></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--Topbar Right End-->
    </header>
    <LeftSideBar :user="user" :key="urlKey()" class="left-aside-default" :class="{'left-aside-open': toggle_aside}"></LeftSideBar>
    <!--Topbar End Here-->
    <TutorSteps :user="user" v-if="checkUserTutorStatus()"></TutorSteps>
  </div>
</template>
<script>
import { setCookie } from '../../assets/js/elffy_js/cookie.js'
import LeftSideBar from './LeftSideBar'
import TutorSteps from '../Users/TutorSteps'
import { getCookie } from '../../assets/js/elffy_js/cookie.js'

import Vue from 'vue';

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    window.event = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', window.event)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', window.event)
  },
});

export default {
  name: 'topbar',
  components: {
    LeftSideBar,
    TutorSteps,
  },
  data() {
    return {
      loading: false,
      keyword: '',
      showResult: false,
      loadingTimer: null,
      searchTimer: null,
      searchResult: '',
    }
  },
  created() {

  },
  props: ['toggle_aside', 'user'],
  computed: {
    totalSearchResult: function() {
      var t = 0
      $.each(this.searchResult, function(i, val) {
        t += val.length
      })
      return t
    },
  },
  methods: {
  	logout() {
      const vm = this;
      this.axios.delete('sessions').then(
        function(response) {
          if (response.status == 200) {
            var date = new Date();
            date.setTime(date.getTime() + (1))
            document.cookie = 'auth_token=' + getCookie('auth_token') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'aside_bar=' + getCookie('aside_bar') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'filter_deal_owner=' + getCookie('filter_deal_owner') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'deal_filter=' + getCookie('deal_filter') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            vm.$router.push('/login')
            vm.$toastr.w('記得回來喔，我會想你的 :(')
          } else {
            console.log('error:', 'User Logout Fail')
          }
        })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    checkUserTutorStatus() {
      return this.user && (this.user.is_teached == false)
    },
    toggle() {
      this.$emit('input', !this.toggle_aside)
      setCookie('aside_bar', !this.toggle_aside, 7)
    },
    GoDashbaord() {
      this.$router.push('/dashboard')
    },
    GoUserProfile() {
      this.$router.push('/user_profile')
    },
    goCreditCard(){
      this.$router.push('/setting/credit_card_binding')
    },
    goBills(){
      this.$router.push('/setting/bills')
    },
    goPlans(){
      this.$router.push('/setting/plans')
    },

    ShowDeal(deal_token) {
      window.open("/deal/" + deal_token, "_blank");
      //this.$router.push({ name: 'deal', params: { deal_token: deal_token } })
    },
    ShowContact(contact_token) {
      window.open("/contact/" + contact_token, "_blank");
      //this.$router.push({ name: 'contact', params: { contact_token: contact_token } })
    },
    ShowOrganization(organization_token) {
      window.open("/organization/" + organization_token, "_blank");
      //this.$router.push({ name: 'organization', params: { organization_token: organization_token } })
    },
    ShowQuotation(quotation_token) {
      window.open("/quotation/" + quotation_token, "_blank");
      //this.$router.push({ name: 'show_quotation', params: { quotation_token: quotation_token } })
    },
    DownLoadFile(url) {
      window.open(url, "_blank");
    },
    hide() {
      this.searchResult = false
    },
    urlKey() {
      //只在行事曆頁面切換的時候，讓左邊邊欄刷新
      var result = "nochange"
      if (this.$route.fullPath == '/activities') {
        result = "change"
      }
      return result
    },
    searchKeyWord() {
      const vm = this;
      vm.showResult = false
      vm.searchResult = ''
      if (vm.keyword.length >= 1) {
        vm.loading = true
        if (this.loadingTimer) {
          clearTimeout(this.loadingTimer)
        }
        this.loadingTimer = setTimeout(() => vm.loading = false, 4000)

        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => vm.startSearchKeyWord(), 1000)
      } else {

      }
    },
    startSearchKeyWord() {
      const vm = this;
      this.axios.post('searchs', {
          search_where: 'all',
          keyword: vm.keyword
        })
        .then(function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.showResult = true
            vm.searchResult = response['data']['data']
          } else {
            console.log('Error')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    }
  }
}

</script>
<style>
.btn-top-word {
  line-height: 60px;
  width: auto !important;
  padding: 0px 20px;
}

</style>



// WEBPACK FOOTER //
// TopBar.vue?df997aa8